// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1qbxW","rootSuccess":"CompleteLink_rootSuccess__5azma","rootFailure":"CompleteLink_rootFailure__1TsPy","isDisabled":"CompleteLink_isDisabled__A5BcX"};